import moment from "moment";

/** Format payment due date; supports Alert format (e.g. "2/7/2025 12:00:00 AM") and ISO. */
export function formatPaymentDue(dateStr: string): string {
  if (!dateStr || typeof dateStr !== "string") return "—";
  const trimmed = dateStr.trim();
  const parsed = moment(trimmed, "M/D/YYYY h:mm:ss A", true).isValid()
    ? moment(trimmed, "M/D/YYYY h:mm:ss A")
    : moment(trimmed, moment.ISO_8601, true).isValid()
      ? moment(trimmed)
      : null;
  return parsed?.isValid() ? parsed.format("DD MMM YYYY") : "—";
}

export function formatDateShort(dateStr: string): string {
  if (!dateStr || typeof dateStr !== "string") return "—";
  const trimmed = dateStr.trim();
  const parsed = moment(trimmed, "M/D/YYYY h:mm:ss A", true).isValid()
    ? moment(trimmed, "M/D/YYYY h:mm:ss A")
    : moment(trimmed, moment.ISO_8601, true).isValid()
      ? moment(trimmed)
      : null;
  return parsed?.isValid() ? parsed.format("DD MMM") : "—";
}
